// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture{display:inline-block;overflow:hidden;transition:opacity .2s;width:100%}.picture:not(.loaded){background:linear-gradient(25deg,var(--light) 40%,var(--gray) 200%);font-size:0;height:100%;min-height:50px;opacity:.3}.picture img{height:auto;margin:0 auto;max-width:100%;width:auto}", ""]);
// Exports
module.exports = exports;
